import styled from 'styled-components';

export const StyledGetHelpPage = styled.div`
  display: flex;
  flex-direction: column;
`;